import { Component, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { SelectedNavContextService } from './layout/context-menu/nav.context.service';
import { ScheduleService } from './common/schedule.service/schedule.service';
import { MaintenanceNotificationJob } from './schedule.jobs/maintenance.notification.job';
import { NotificationService } from './common/notification.service/notification.service';
import { MaintenanceMessageService } from './modules/maintenance.message/maintenance.message.service';
import { MaintenanceModalJob } from './schedule.jobs/maintenance.modal.job';
import { MaintenanceMessageFetchService } from './modules/maintenance.message.modal/maintenance.message.service';
import { MaintenanceMessageModalService } from './modules/maintenance.message.modal/maintenance.message.modal.service';
import { Subscription } from 'rxjs';
import { AuthService } from './services/auth.service';
import { MessageService } from './common/message.service/message.service';
import { Router } from '@angular/router';
import { KPIService } from './modules/kpi/kpi.service';
import { IndicatorUpdater } from './schedule.jobs/IndicatorUpdater';
import { ConfigurationService } from './configuration/configuration.service';
import { ProfileService, UniversalService } from './modules';
import { SignalRService } from './services/signalr.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.pug',
  styleUrls: ['./app.component.sass'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'app';
  theme = 'light';
  public watermarkText: string;

  private messageThemeSub: Subscription;
  private isAuthorizedSubscription: Subscription;
  private userDataSubscription: Subscription;
  public isAuthorized: boolean;

  constructor(
    private authService: AuthService,
    private router: Router,
    private navContextService: SelectedNavContextService,
    private scheduler: ScheduleService,
    private ns: NotificationService,
    private mms: MaintenanceMessageService,
    private mmfs: MaintenanceMessageFetchService,
    private mmms: MaintenanceMessageModalService,
    private messageService: MessageService,
    private kpiService: KPIService,
    private configurationService: ConfigurationService,
    private profileService: ProfileService,
    private signalRService: SignalRService,
    private universalService: UniversalService
  ) {
    this.watermarkText = this.configurationService.watermark;
    document.title = this.watermarkText;

    const job1 = new MaintenanceNotificationJob(this.ns, this.mms, this.mmfs, this.authService, this.signalRService);
    this.scheduler.add(job1);

    const job2 = new MaintenanceModalJob(this.mmms, this.mmfs, this.authService);
    this.scheduler.add(job2);

    this.messageThemeSub = this.messageService
      .getTheme()
      .subscribe(themeName => {
        this.theme = themeName.text;
        localStorage.setItem('ThemeCode', this.theme);
      });

    this.theme = localStorage.getItem('ThemeCode') || 'light';
  }
  IndicatorJob: IndicatorUpdater;
  ngOnInit() {
    this.isAuthorizedSubscription = this.authService.getIsAuthorized().subscribe(
      async (isAuthorized: boolean) => {
        if (this.isAuthorized && !isAuthorized) {
          console.log('Kiléptetés folyamatban.');
          this.router.navigate(['/']);
        }

        this.isAuthorized = isAuthorized;

        if (this.isAuthorized) {
          this.authService.userRefreshed.subscribe(async () => {
            if (!this.configurationService.nyilvantartasiModulConfiguration.nyilvantartasok) {
              const itm = await this.universalService.getItemTypesForMenu();
              this.configurationService.nyilvantartasiModulConfiguration.nyilvantartasok = itm.elemTipusok;
              this.configurationService.nyilvantartasiModulConfiguration.menucsoportok = itm.menuCsoportok;
              this.configurationService.NyilvantartasiModulInicializalva.emit(true);
            }

            this.signalRService.startConnection(this.authService);
          });
        }
      });

    this.userDataSubscription = this.authService.getUser().subscribe(
      async (userData: any) => {
        if (userData.mandatory_update) {
          setTimeout(() => this.router.navigate(['profile/edit']), 1);
          return;
        }
        if (userData.mandatory_authenticator) { window.location.href = '/auth/Manage/TwoFactorAuthentication'; return; }

        if (userData.profile_id) {
          this.IndicatorJob = this.IndicatorJob || new IndicatorUpdater(userData.profile_id, this.kpiService);

          this.kpiService.update(userData.profile_id);

          if (this.IndicatorJob.profileId !== userData.profile_id) {
            this.IndicatorJob.profileId = userData.profile_id;
            this.scheduler.add(this.IndicatorJob, true);
          } else {
            this.scheduler.add(this.IndicatorJob);
          }
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.isAuthorizedSubscription.unsubscribe();
    this.messageThemeSub.unsubscribe();
    this.userDataSubscription.unsubscribe();
  }

  public hasContextMenu(): boolean {
    return !!(this.navContextService && this.navContextService.currentReference);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts